import {createSelector} from 'reselect';
import {isInApp} from '../../../utils/user-agent';
import {getSettings} from '../../selectors';

export const getShouldHideGooglePay = state => !state.payment.isGooglePayAvailable
  || (isInApp() && getSettings(state)?.should_hide_google_pay_in_app);

const getPaymentOptions = state => state.payment.options;

export const getGooglePayMethod = createSelector(
  [getPaymentOptions],
  paymentOptions => paymentOptions.find(option => option.type === 'GOOGLEPAY'),
);

export const getGooglePayPublicKey = createSelector(
  [getGooglePayMethod],
  googlePayMethod => googlePayMethod.publicKey,
);

export const getGooglePayMerchantId = createSelector(
  [getGooglePayMethod],
  googlePayMethod => googlePayMethod.merchantId,
);

export const getGooglePayEnvironment = createSelector(
  [getGooglePayMethod],
  googlePayMethod => googlePayMethod.environment,
);

export const getGooglePayJwt = createSelector(
  [getGooglePayMethod],
  googlePayMethod => googlePayMethod.jwt,
);

export const getAcquirerBankCountryCode = createSelector(
  [getGooglePayMethod],
  googlePayMethod => googlePayMethod.acquirerBankCountryCode,
);

export const getGooglePayPaymentData = state => state.payment.googlePayPaymentData;

export const getGooglePayBillingAddress = createSelector(
  [getGooglePayPaymentData],
  googlePayPaymentData => googlePayPaymentData.paymentMethodData.info.billingAddress,
);
